module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.15137/js/img/white_sprocket.svg"